export class EqualizationData {
  icfr: number;
  groupDelay: number;
  bandwidth: number;
  mainTapLocation: number;
  postMainTap: number;
  postMainTapEnergy: number;
  ripples: number;
  icfrGraphPoints: number[];
  tapGraphPoints: number[];
  frequency: number;
  mainTapRatio: number;
  txPower: number;
  coefficient: string;
  locked: boolean;
}
